if (!customElements.get('jp-autumn-sale')) {
  customElements.define('jp-autumn-sale', class extends HTMLElement {
    connectedCallback() {
      this.endsAt = Date.parse(this.dataset.endsAt);
      this.clock = this.querySelector('[data-sale-clock]');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
      if (!Number.isFinite(this.endsAt)) return;
      this.disconnectedCallback();
      if (this.update()) this.interval = window.setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.units.forEach((unit, index) => { unit.textContent = String(values[index]).padStart(2, '0'); });
      this.clock.hidden = false;
      if (remaining === 0) this.disconnectedCallback();
      return remaining > 0;
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }
  });
}
